import { useUpdateEffect } from 'react-use';
import styled from 'styled-components';

import { useFormController } from '@dreryk/react-common';
import { ActionInput } from '@dreryk/react-components';

import { medicalServiceTranslationKeys } from '../../translations';

export const StyledActionInput = styled(ActionInput)`
   width: 537px;
`;

StyledActionInput.displayName = 'StyledActionInput';

type MedicalServiceTableSearchFormBean = {
   searchText: string | null;
};

type MedicalServiceTableSearchProps = {
   readonly onChange: (searchText: string | null) => void;
};

export const MedicalServiceTableSearch = (props: MedicalServiceTableSearchProps): JSX.Element => {
   const { register, watch } = useFormController<MedicalServiceTableSearchFormBean>({ searchText: null });
   const searchText = watch('searchText');

   useUpdateEffect(() => props.onChange(searchText), [searchText]);

   return (
      <StyledActionInput
         controller={register('searchText')}
         placeholder={medicalServiceTranslationKeys.table.search.placeholder}
         autoFocus
         testId={'medicalService'}
      />
   );
};
